import React from "react";
import leftarrow from "@/assets/images/page_nav_icon_left.svg";
import rightarrow from "@/assets/images/page_nav_icon_right.svg";

const PageChanger = ({ page, totalPages, onPageChange }) => {
  const handlePrevious = () => {
    if (page > 1) {
      onPageChange(page - 1);
    }
  };

  const handleNext = () => {
    if (page < totalPages) {
      onPageChange(page + 1);
    }
  };

  const renderPageNumbers = () => {
    const pageNumbers = [];

    const getPageNumber = (i) => (
      <div
        key={i}
        className={`changer-page-number ${page === i ? "active" : ""}`}
        onClick={() => onPageChange(i)}
      >
        {i}
      </div>
    );

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(getPageNumber(i));
      }
      return pageNumbers;
    }

    pageNumbers.push(getPageNumber(1));

    if (page > 3) {
      pageNumbers.push(<div key="start-ellipsis">...</div>);
    }

    let start = Math.max(2, page - 1);
    let end = Math.min(totalPages - 1, page + 1);

    if (page < 4) {
      start = 2;
      end = 4;
    } else if (page > totalPages - 3) {
      start = totalPages - 3;
      end = totalPages - 1;
    }

    for (let i = start; i <= end; i++) {
      pageNumbers.push(getPageNumber(i));
    }

    if (page < totalPages - 2) {
      pageNumbers.push(<div key="end-ellipsis">...</div>);
    }

    pageNumbers.push(getPageNumber(totalPages));

    return pageNumbers;
  };

  return (
    <div className="page-changer">
      <div className="changer-arrow-container" onClick={handlePrevious}>
        <img src={leftarrow} alt="Previous" />
      </div>
      <div className="changer-page-numbers">{renderPageNumbers()}</div>
      <div className="changer-arrow-container" onClick={handleNext}>
        <img src={rightarrow} alt="Next" />
      </div>
    </div>
  );
};

export default PageChanger;
